import { fetch } from '@atlassian/eoc-fetch';
import { urls } from '../../../common/constants/urls';
const getUiPreferences = teamId => {
  return fetch(urls.uiPreference.schedule.team.teamId.url({
    teamId
  }));
};
const updateUiPreferences = ({
  teamId,
  key,
  value
}) => {
  return fetch(urls.uiPreference.schedule.team.teamId.url({
    teamId
  }), {
    method: 'PATCH',
    body: {
      [key]: value
    }
  });
};
export const endpoints = {
  getUiPreferences,
  updateUiPreferences
};